import { ANIMATION_DURATIONS } from "./consts";
import wait from "./wait";

export default async function playCardSounds({
  player,
  sound = undefined,
  nCards = 0,
  delay = ANIMATION_DURATIONS.correctCardStagger_ms,
}) {
  if (!player || sound === undefined || nCards === 0) {
    return;
  }

  if (delay === 0) {
    player.play(sound);
    return;
  }

  for (let i = 0; i < nCards; i++) {
    player.play(sound);
    await wait(delay);
  }
}
